import {AbstractModel} from '../abstract-model';
import {PageType} from '../page-type';
import {PoolLandingPage} from './pool-landing-page';
import {PoolMode} from '../../constants/pool-mode';

export class Pool extends AbstractModel {

  id: number | null = null;
  identifier: string | null = null;
  name: string | null = null;
  type: PageType | null = null;
  enabled: boolean = true;
  poolLandingPages: PoolLandingPage[] = [];
  mode: string = PoolMode.RANDOM;
  cappingCount: number | null = null;
  cappingDuration: number | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.type) {
      this.type = new PageType().deserialize(input.type);
    }

    if (input.poolLandingPages) {
      this.poolLandingPages = input.poolLandingPages.map((landingPage: any) => new PoolLandingPage().deserialize(landingPage));
    }

    return this;
  }

  override toString(): string {
    return this.name ?? '';
  }
}
